
import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { StringHelper } from '../../core/helpers/strings.helper';

// @ts-ignore

@Pipe({
	name: 'moneyFormat'
})

// @ts-ignore
export class MoneyFormatPipe extends CurrencyPipe implements PipeTransform {

	transform(value: number, currencyCode?: any): any {
		let moneyDecimal = `${value}`;

		const dotPosition = moneyDecimal.lastIndexOf('.');

		if (dotPosition > 0) {
			moneyDecimal = moneyDecimal.substring(dotPosition + 1);
		}
		else {
			moneyDecimal = '00';
		}

		return moneyDecimal;
	}

}
